import { ENVIRONMENT } from '@/commons/configuration'
import authenticatedAxios from '@/commons/configuration/authenticated.axios'
import { applicantStore, userStore } from '@/store'
import i18n from '@/commons/translations/i18n'
import { ValidDocumentType } from '@/commons/constants/application'
import { DocumentResponse } from '@/commons/types/document'

export class DocumentService {
    static async getValidDocuments (): Promise<Array<DocumentResponse>> {
        if (userStore.validDocuments !== null) {
            return userStore.validDocuments
        }

        const url = ENVIRONMENT.validDocumentsUrl
        const response = await authenticatedAxios.get(url, {
            params: {
                personCode: userStore.personCode
            }
        })
        userStore.validDocuments = response.data
        return response.data
    }

    static async getValidDocumentsForRepresentative (): Promise<Array<DocumentResponse>> {
        if (applicantStore.validDocuments !== null) {
            return applicantStore.validDocuments
        }

        const response = await authenticatedAxios.get(ENVIRONMENT.validDocumentsUrl, {
            params: {
                personCode: applicantStore.personCode
            }
        })
        applicantStore.validDocuments = response.data
        return response.data
    }

    static getDocumentTypeAsString (documentType: string): string {
        switch (documentType) {
        case ValidDocumentType.CITIZEN_PASSPORT:
            return i18n.t('validDocuments.type.citizenPassport').toString()
        case ValidDocumentType.ID_CARD:
            return i18n.t('validDocuments.type.citizenIdCard').toString()
        case ValidDocumentType.ALIEN_PASSPORT:
            return i18n.t('validDocuments.type.alienPassport').toString()
        case ValidDocumentType.RESIDENCE_CARD:
            return i18n.t('validDocuments.type.residenceCard').toString()
        case ValidDocumentType.SEAFARERS_DISCHARGE_BOOK:
            return i18n.t('validDocuments.type.seafarerDischargeBook').toString()
        case ValidDocumentType.CERTIFICATE_OF_SERVICE_ON_SHIPS:
            return i18n.t('validDocuments.type.certificateOfServiceShips').toString()
        case ValidDocumentType.TEMPORARY_PASSPORT:
            return i18n.t('validDocuments.type.temporaryPassport').toString()
        case ValidDocumentType.DIGITAL_ID:
            return i18n.t('validDocuments.type.digitalId').toString()
        case ValidDocumentType.ADDITIONAL_PASSPORT:
            return i18n.t('validDocuments.type.additionalPassport').toString()
        default:
            return i18n.t('validDocuments.type.unknown').toString()
        }
    }
}
